// Image conversion utilities
export const convertToWebP = (file, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      // Set canvas dimensions
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Draw image on canvas
      ctx.drawImage(img, 0, 0);
      
      // Convert to WebP
      canvas.toBlob(
        (blob) => {
          if (blob) {
            // Create new file with .webp extension
            const webpFileName = file.name.replace(/\.(png|jpg|jpeg)$/i, '.webp');
            const webpFile = new File([blob], webpFileName, { type: 'image/webp' });
            resolve(webpFile);
          } else {
            reject(new Error('Failed to convert image to WebP'));
          }
        },
        'image/webp',
        quality
      );
    };
    
    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };
    
    // Load the image
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

// Batch convert multiple images to WebP
export const batchConvertToWebP = async (files, onProgress) => {
  const webpFiles = [];
  
  for (let i = 0; i < files.length; i++) {
    try {
      const webpFile = await convertToWebP(files[i]);
      webpFiles.push(webpFile);
      
      if (onProgress) {
        onProgress(i + 1, files.length);
      }
    } catch (error) {
      console.error(`Failed to convert ${files[i].name}:`, error);
      // Continue with other files
    }
  }
  
  return webpFiles;
};
